import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class ProviderContactInfoModel extends BaseModel {
  static urlPath = 'provider-contact-info';

  @attr('number') id;
  @attr('string') display;
  @attr('string') contact_label;
  @attr('number') contact_type;
  @attr('number') related_provider;
  @attr('json') created_by;
  @attr('json') updated_by;
  @attr('datetime') created_at;
  @attr('datetime') updated_at;
}